import _defineProperty from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/web.dom.iterable";
import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.number.constructor";
var _name$components$crea;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moduleConfig from "../moduleConfig";
import request from "@/utils/request";
function _getData(data, url) {
  return request({
    url: url,
    method: "get",
    data: data
  });
}
console.log('🟢 OpFilter 文件被加载！');
export default (_name$components$crea = {
  name: 'OpFilter',
  components: {},
  created: function created() {
    console.log('🟢 OpFilter 实例被创建！', this.componentId, this.title);
  },
  props: {
    api: {
      type: String,
      required: false,
      default: ""
    },
    value: {
      type: null,
      required: false,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String,
      required: false,
      default: ""
    },
    size: {
      type: String,
      required: false,
      default: "mini"
    },
    componentId: {
      type: Number,
      required: true,
      default: 1
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    type: {
      type: String,
      required: false,
      default: "horizontal"
    }
  },
  data: function data() {
    return {
      options2: [{
        label: "红色",
        value: 1
      }, {
        label: "黑色",
        value: 2
      }, {
        label: "白色",
        value: 3
      }, {
        label: "紫色",
        value: 4
      }, {
        label: "青色",
        value: 5
      }, {
        label: "蓝色",
        value: 6
      }, {
        label: "灰色",
        value: 7
      }, {
        label: "双色",
        value: 8
      }],
      dowEnum: [],
      options: [],
      isShowDropDown: false,
      activeIndex: -1,
      checkedFilter: this.value,
      isCheckbox: false,
      moduleConfig: moduleConfig,
      isShowMore: false
    };
  },
  computed: {},
  watch: {
    value: function value() {
      console.log(this.value, 77);
      if (Array.isArray(this.value)) {
        this.checkedFilter = this.value.map(function (item) {
          return JSON.parse(item).value;
        });
      } else {
        this.checkedFilter = this.value;
      }
      if (this.value && this.value.length < 1) {
        this.dowEnum = [];
      }
    }
  }
}, _defineProperty(_name$components$crea, "created", function created() {
  this.getData();
}), _defineProperty(_name$components$crea, "methods", {
  getData: function () {
    var _getData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!!moduleConfig[this.componentId] && this.api)) {
              _context.next = 10;
              break;
            }
            if (!localStorage.getItem(this.api)) {
              _context.next = 5;
              break;
            }
            this.options = JSON.parse(localStorage.getItem(this.api));
            _context.next = 10;
            break;
          case 5:
            _context.next = 7;
            return _getData({}, this.api);
          case 7:
            result = _context.sent;
            this.options = result.data;
            localStorage.setItem(this.api, JSON.stringify(this.options));
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function getData() {
      return _getData2.apply(this, arguments);
    }
    return getData;
  }(),
  rest: function rest() {
    this.dowEnum = [];
    this.checkedFilter = "";
    this.$emit('input', this.checkedFilter);
  },
  showDropDown: function showDropDown(event) {
    console.log(event.currentTarget.offsetLeft);
    this.isShowDropDown = true;
  },
  hideDropDown: function hideDropDown() {
    this.isShowDropDown = false;
  },
  changeFilter: function changeFilter(value, index) {
    var _this = this;
    var currItem = null;
    this.dowEnum = [];
    this.options.forEach(function (item) {
      if (item.value === value) {
        _this.dowEnum.push(item.label);
        currItem = item.value;
      }
    });
    console.log(11, currItem);
    this.dowEnum = this.dowEnum.join('');
    this.$emit('input', currItem);
  },
  handleCheckbox: function handleCheckbox() {
    this.isCheckbox = !this.isCheckbox;
    this.checkedFilter = [];
  },
  collapse: function collapse() {
    this.isShowMore = false;
  },
  showMore: function showMore() {
    this.isShowMore = true;
  },
  cancelMultiple: function cancelMultiple() {
    this.checkedFilter = [];
    this.dowEnum = [];
    this.isCheckbox = false;
    this.$emit('input', this.checkedFilter);
    if (!this.isCheckbox) {
      this.checkedFilter = this.value;
    }
  },
  checkChange: function checkChange() {
    var _this2 = this;
    var items = [];
    this.dowEnum = [];
    this.checkedFilter.forEach(function (key) {
      _this2.options.forEach(function (item) {
        if (key === item.value) {
          console.log(item, 777);
          _this2.dowEnum.push(item.label);
          items.push(JSON.stringify(item));
        }
      });
    });
    this.dowEnum = this.dowEnum.join(',');
    this.$emit('input', items);
  }
}), _name$components$crea);